import { AuthenticatedUser, AuthService, AUTH_EVENT } from '@apparel/core/auth';
import { useCallback, useEffect, useState } from 'react';
import { useMounted } from './useMounted';

interface UseAuth {
    auth: boolean;
    token: string | null | undefined;
    checking: boolean;
    user: AuthenticatedUser | null;

    logout(): void;
}

export const useAuth = (): UseAuth => {
    const [state, setState] = useState(() => AuthService.getInstance().state);
    const isMounted = useMounted();
    const handleState = useCallback(() => {
        if (isMounted()) {
            setState({ ...AuthService.getInstance().state });
        }
    }, [setState, AuthService.getInstance().state, isMounted]);

    useEffect(() => {
        if (!process['browser']) {
            return;
        }

        const auth = AuthService.getInstance();
        const state = auth.state;

        handleState();

        const offLogin = auth.on(AUTH_EVENT.LOGIN, handleState);
        const offCheck = auth.on(AUTH_EVENT.CHECK, handleState);
        const offNoLogin = auth.on(AUTH_EVENT.NO_LOGIN, handleState);
        const offLogout = auth.on(AUTH_EVENT.LOGOUT, handleState);

        if (!state.checking && !state.auth) {
            auth.checkAuthentication();
            state.checking = true;
        }

        return () => {
            offLogin();
            offCheck();
            offNoLogin();
            offLogout();
        };
    }, []);

    return { ...state } as any;
};
